let cookieConsentList = {};

function setUpCookieConsent() {
  cookieConsentList = JSON.parse(document.body.dataset.cookieConsentList ?? "{}");
}

function updateCookieConsentList(updatedList) {
  cookieConsentList = updatedList;
}

function userHasConsented(cookieCode) {
  return cookieConsentList[cookieCode] ?? false;
}

export {setUpCookieConsent, updateCookieConsentList, userHasConsented};
